// src/components/TestimonialCard.js
import React from 'react';
import './TestimonialCard.css';

export default function TestimonialCard({ testimonial }) {
    return (
        <div className="testimonial-card fade-in">
            <div className="testimonial-image">
                <img src={testimonial.image} alt={testimonial.name} />
            </div>
            <div className="testimonial-content">
                <p>"{testimonial.quote}"</p>
                <h3>- {testimonial.name}</h3>
            </div>
        </div>
    );
}
